export function capitalize(textToBeCapitalized) {
  return textToBeCapitalized.charAt(0).toUpperCase() + textToBeCapitalized.slice(1);
}